export default class CourseRunDetails {
    constructor(raw = {}) {
        this.certificateLink = raw.certificateLink;
        this.percentage = raw.percentage;
        this.startDate = raw.startDate;
        this.successDate = raw.successDate;
        this.failureDate = raw.failureDate;
        this.lastSyncDate = raw.lastSyncDate;
        this.syncIssueDate = raw.syncIssueDate;
        this.syncIssueReason = raw.syncIssueReason;
    }

    getEndDate() {
        return this.successDate ?? this.failureDate;
    }

    get syncIssueLabel() {
        const labels = {
            progress_request_failed: "Speichern des Fortschritts fehlgeschlagen",
            sync_stale: "Synchronisierung während der laufenden Schulung unterbrochen",
            scorm_connection_late: "Keine Verbindung zum Schulungspaket",
            state_capture_failed: "Kurszustand konnte nicht gelesen werden",
            empty_scorm_state: "Kurszustand ist leer",
        };

        return labels[this.syncIssueReason] || this.syncIssueReason || "Unbekanntes Sync-Problem";
    }
}
